import React, { memo, useState, useCallback } from "react"
import styled from "styled-components"
import { Form, Field } from "react-final-form"

import { useCreateEmailList } from "graphql/mutations/createEmailList"

import { Flex } from "components/box"
import { Paragraph, Eyebrow, H4 } from "components/text"
import { SupportPhoneLink } from "components/support-links"
import { CreateEmailListParams } from "typings/types"

const Input = styled.input`
  flex: 1;
  background: none;
  border-top-left-radius: ${props => props.theme.space[1]};
  border-bottom-left-radius: ${props => props.theme.space[1]};
  color: ${props => props.theme.colors.white};
  padding: ${props => props.theme.space[4]};
  border: 2px ${props => props.theme.colors.paleAqua} solid;
`

const Button = styled.button`
  margin: 0 auto;
  padding: ${props => props.theme.space[4]} ${props => props.theme.space[5]};
  border: 2px ${props => props.theme.colors.paleAqua} solid;
  border-top-right-radius: ${props => props.theme.space[1]};
  border-bottom-right-radius: ${props => props.theme.space[1]};
  background-color: ${props => props.theme.colors.paleAqua};
`

const SubscriberForm = () => {
  const [createEmailList, { loading }] = useCreateEmailList()
  const [message, setMessage] = useState("")

  const initialValues: CreateEmailListParams = {
    email: ""
  }

  const onSubmit = useCallback(async (values: CreateEmailListParams) => {
    const result = await createEmailList({
      variables: {
        emailList: values
      }
    })

    if (result && result.data) {
      setMessage("Thanks! You've signed up successfully.")
      return
    }

    setMessage("Oops, the server couldn't be reached. Try again soon!")
  }, [])

  return (
    <>
      <H4 mb={5}>Stay ahead of it</H4>
      <Form
        initialValues={initialValues}
        subscription={{ values: true }}
        onSubmit={onSubmit}
        render={({ handleSubmit, form: { reset } }) => (
          <form
            onSubmit={async event => {
              await handleSubmit(event)

              // Tried to call it into onSubmit function but it works only here
              reset()
            }}
          >
            <Eyebrow>Email</Eyebrow>
            <Flex alignItems="center" mt={5}>
              <Field
                name="email"
                render={({ input }) => (
                  <Input
                    {...input}
                    onChange={event => {
                      message && setMessage("")
                      input.onChange(event)
                    }}
                    required
                  />
                )}
              />
              <Button disabled={loading}>&#10217;</Button>
            </Flex>
            {message && <Paragraph mt={2}>{message}</Paragraph>}
            <Flex mt={6} color="ice">
              <Paragraph bold mr={2}>
                Need help?
              </Paragraph>
              <Paragraph>
                Call us toll-free <SupportPhoneLink />
              </Paragraph>
            </Flex>
          </form>
        )}
      />
    </>
  )
}

export default memo(SubscriberForm)
